var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04004 12.2847V1.36328H14.3701V12.2847",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20475 7.43164L2.03972 12.2821L1.8584 2.67188",
    fill: "black",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0399 12.2835H0.997285C0.453311 12.2835 0 11.8302 0 11.2409V0.996094H2.0399V12.2835Z",
    fill: "#D54C3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9702 12.2848H14.4607V1.72266H0.317383",
    fill: "black",
    fillOpacity: 0.08
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.99707 0H15.4124L8.20472 5.12242",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3701 12.2835H15.4127C15.9567 12.2835 16.41 11.8302 16.41 11.2409V0.996094H14.3701V12.2835Z",
    fill: "#B63524"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.99707 0.996094L8.20472 6.20917L15.4124 0.996094",
    stroke: "#DE5145",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.a1151a2307a6a66f9b2ea6180acde010.svg";
export { ForwardRef as ReactComponent };